module.exports = __webpack_public_path__ + "img/tu06.2fce3e58.jpg";